var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#151515",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_584_5351",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_584_5351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 23.7885V15.3885L16.7848 17.8538L15.7308 16.7693L20 12.5L24.2693 16.7693L23.2153 17.8538L20.75 15.3885V23.7885H19.25ZM14.3078 27.5C13.8026 27.5 13.375 27.325 13.025 26.975C12.675 26.625 12.5 26.1974 12.5 25.6923V22.9808H14V25.6923C14 25.7693 14.0321 25.8398 14.0963 25.9038C14.1603 25.9679 14.2308 26 14.3078 26H25.6923C25.7693 26 25.8398 25.9679 25.9038 25.9038C25.9679 25.8398 26 25.7693 26 25.6923V22.9808H27.5V25.6923C27.5 26.1974 27.325 26.625 26.975 26.975C26.625 27.325 26.1974 27.5 25.6923 27.5H14.3078Z",
    fill: "#151515"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.aa9ffca54308720efa92cb022958692d.svg";
export { ForwardRef as ReactComponent };